import {
  AuthManager,
  Billing,
  Claims,
  Consumption,
  CustomerDataManager,
  DataSharing,
  ErrorHandler,
  Logger,
  LoveManager,
  MessageBus,
  ModuleLoader,
  Ost,
  Products,
  Payment,
  Router,
  TagManager,
} from '@oskecare/infrastructure';
import { config } from './config.js';

// Infrastructure singleton instantiation
export const messageBus = new MessageBus();
export const logger = new Logger({ messageBus, config });
export const authManager = new AuthManager({ logger, config });
export const errorHandler = new ErrorHandler({ logger, authManager, config });
export const tagManager = new TagManager({ messageBus, authManager, config });
export const customerDataManager = new CustomerDataManager({
  messageBus,
  logger,
  authManager,
  tagManager,
  config,
});
export const consumption = new Consumption({ logger, customerDataManager, config });
export const products = new Products({ logger, customerDataManager, config });
export const dataSharing = new DataSharing({ customerDataManager, products, logger });
export const loveManager = new LoveManager({ customerDataManager, products, logger });
export const billing = new Billing({ config, logger, customerDataManager });
export const moduleLoader = new ModuleLoader({ logger });
export const payment = new Payment({ config, logger, billing, customerDataManager });
export const ost = new Ost({ config, logger, customerDataManager, dataSharing, products });
export const claims = new Claims({ config, logger, messageBus });
export const router = new Router({ messageBus, customerDataManager, logger, config });

export const infrastructure = {
  authManager,
  billing,
  claims,
  consumption,
  customerDataManager,
  dataSharing,
  logger,
  loveManager,
  messageBus,
  moduleLoader,
  ost,
  products,
  payment,
  router,
  tagManager,
};
